import "../css/Loader.css";
import "../css/LoaderInside.css"; // Import the CSS for styling
// Import the CSS for styling

const Loader = ({ text }) => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
      <p>{text}</p>
    </div>
  );
};
const LoaderInside = ({ text }) => {
  return (
    <>
      {/* <p>{text}</p> */}
      <div className="loader-inside"></div>
    </>
  );
};

export { Loader, LoaderInside };
